export default "<h1> Portal - Device Types</h1>\r\n<p>Provides an aggregated overview of the type of Devices accessing the Portal.</p>\r\n\r\n";